import React from "react";
import {
    Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Stack,
    Container
} from "@mui/material";
import TableDataWithPagination from "../../BuiltInComponent/TableWithPagination";
import Loading from '../../BuiltInComponent/Loading'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import Navbar from '../setup/Navbar'
import { Grid2 } from "@mui/material";
import TextFields from "../../BuiltInComponent/TextField";
import { getAllowances, getSingleAllowances, addAllowance, editAllowance, deleteAllowance } from "../../features/AdminManagement/allowancesSlice";
import { useDispatch, useSelector } from "react-redux";
// import { allowancesApi } from "../api/allowancesApi";

const defaultForm = {
    allownceID: "",
    allownceDescription: "",
    allownceStatus: 1,
};

export default function AllowancesPage() {

    const dispatch = useDispatch();

    const { isLoading } = useSelector((state) => state.allowances);
    const [rows, setRows] = React.useState([]);

    const [open, setOpen] = React.useState(false);
    const [formData, setFormData] = React.useState(defaultForm);
    const [editMode, setEditMode] = React.useState(false);

    React.useEffect(() => {
        dispatch(getAllowances()).then((res) => {
            const mapped = (res.payload || []).map((x) => ({
                ...x,
                edit: "Edit",
                delete: "Delete",
            }));
            setRows(mapped);

        })
    }, [dispatch]);

    // ========= Handlers =========
    const handleOpenAdd = () => {
        setEditMode(false);
        setFormData(defaultForm);
        setOpen(true);
    };

    const onEdit = (id) => {
        setEditMode(true);
        dispatch(getSingleAllowances(id)).then((res) => {
            console.log(res.payload)
            setFormData({
                allowanceID: res.payload.allowanceID,
                allowanceDescription: res.payload.allowanceDescription,
                allowanceStatus: Number(res.payload.allowanceStatus ?? 1),
            });

        })
        setOpen(true);
    };

    const onDelete = async (id) => {
        try {
            dispatch(deleteAllowance(id)).then((res) => {
                dispatch(getAllowances()).then((res) => {
                    setRows(res.payload)
                })
            });
        } catch (e) {
            console.error(e);
            alert(e.message);
        }
    };

    const onChange = (e) => {
        const [key, value] = Object.entries(e)[0];
        // status tinyint ko number me rakhein
        const v = key === "allowanceStatus" ? Number(value) : value;
        setFormData((s) => ({ ...s, [key]: v }));
    };

    const handleSave = async () => {
        const payload = {
            allowanceDescription: formData.allowanceDescription?.trim(),
            allowanceStatus: Number(formData.allowanceStatus ?? 1),
        };

        if (!payload.allowanceDescription) {
            alert("Description required");
            return;
        }

        try {
            if (editMode) {
                dispatch(editAllowance({ id: formData.allowanceID, ...payload })).then((res) => {
                    dispatch(getAllowances()).then((res) => {
                        setRows(res.payload)
                    })

                });
            } else {
                dispatch(addAllowance(payload)).then((res) => {

                    dispatch(getAllowances()).then((res) => {
                        setRows(res.payload)
                    })
                })
            }
            setOpen(false);
            // await loadData();
        } catch (e) {
            console.error(e);
            alert(e.message);
        }
    };

    // ========= Table Columns (Ref-1 pattern) =========
    const tableColumns = [
        { fieldName: "allowanceID", cName: "ID", width: 10, textAlign: "left", status: "en" },
        { fieldName: "allowanceDescription", cName: "Description", width: 30, textAlign: "left", status: "en" },
        {
            fieldName: "allowanceStatus", cName: "Status", width: 15, textAlign: "left", status: "en",
            // Optional: display mapping if your table supports a render/format hook
            // render: (val) => (Number(val) === 1 ? "Active" : "Inactive")
        },
        { fieldName: "edit", cName: "Edit", width: 10, textAlign: "center", status: "en" },
        { fieldName: "delete", cName: "Delete", width: 10, textAlign: "center", status: "en" },
        { fieldName: "delete", cName: "Delete", width: 10, textAlign: "center", status: "dis" },
    ];

    return (
        <>
            <Navbar />
            <Container>
                <Box p={2}>
                    <HeadingText text="Allowances" />
                    <Stack direction="row" justifyContent="right" alignItems="center" mb={2} mt={2}>
                        <Button variant="contained" onClick={handleOpenAdd}>Add Allowance</Button>
                    </Stack>
                    {
                        isLoading ? <><Loading /></> : <>
                            <TableDataWithPagination
                                tableData={rows}
                                tableColumns={tableColumns}
                                onEditClick={onEdit}
                                onDeleteClick={onDelete}
                                perPage={5}
                            />
                        </>
                    }

                    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                        <DialogTitle>{editMode ? "Edit Allowance" : "Add Allowance"}</DialogTitle>
                        <DialogContent dividers>
                            <AllowanceForm formData={formData} onChange={onChange} />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpen(false)}>Cancel</Button>
                            <Button variant="contained" onClick={handleSave}>
                                {editMode ? "Update" : "Save"}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            </Container>
        </>
    );
}


function AllowanceForm({ formData, onChange }) {
    const funcOnChange = onChange
    return (
        <Grid2 container spacing={2}>
            {/* ID (Auto Increment) - disabled like your PR ID example */}
            <Grid2 size={12}>
                <TextFields
                    label="Allowance ID"
                    name="allowanceID"
                    value={formData.allowanceID ?? ""}
                    onChange={onChange}
                    disStatus={true}
                />
            </Grid2>

            {/* Description */}
            <Grid2 size={12} >
                <TextFields
                    label="Allowance Description"
                    name="allowanceDescription"
                    value={formData.allowanceDescription ?? ""}
                    onChange={funcOnChange}
                    disStatus={false}
                />
            </Grid2>
        </Grid2>
    );
}
